module.exports = __webpack_public_path__ + "static/insights-hero-3b058d14beb6833c7dc7ae5a3fc99a2b.jpg";